import { Rule } from "@shared/types";

import { authPut } from "../auth";

import { RulePostParams } from "./types";
export const putRule = (id: string, data: RulePostParams) => {
  return authPut<RulePostParams, Rule>(`/api/registry/rules/${id}`, data);
};
